import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarFornecedor from "./CadastrarFornecedor";


const EditarFornecedor = () => {
    const { id } = useParams();

    return <CadastrarFornecedor fornecedorId={id} />;
};

export default EditarFornecedor;
